<template>
    <v-app>
        <app-toolbar></app-toolbar>
        <app-nav-drawer></app-nav-drawer>
        <v-content>
            <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
import Toolbar from "./components/layout/Toolbar";
import NavDrawer from "./components/layout/NavDrawer";

export default {
    name: "App",
    components: {
        appToolbar: Toolbar,
        appNavDrawer: NavDrawer
    },
    beforeRouteUpdate(to, from, next) {
        if(to.name === 'home') {
            this.loadRoundInProgress();
        }
        next();
    }
};
</script>
